<template >
    <div v-if="isVisible" class="audience-table-container">
        <h3>Usuarios que han interactuado previamente con tu empresa</h3>
        <div class="audience-table-box">
            <table class="table">
                <tbody>
                  <tr>
                    <td>Todos los visitantes (Google Ads)</td>
                    <td>Visitantes del sitio web</td>
                    
                  </tr>
                  <tr>
                    <td>Todos los visitantes (Google Ads) Definida por el sistema</td>
                    <td>Visitantes del sitio web</td>
                  </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    name: "audience-table",
  props: {
    isVisible: false,
  },
  data() {
    return{
      
    }
  },
  async created() {
    
  },
}
</script>
<style lang="scss" scoped>
    .audience-table-container{
        margin-bottom: 50px;
        h3{
            margin-bottom: 15px;
        }
    }
    .audience-table-box{
        background: white;
        border: 1px solid rgb(234, 234, 234);
        border-left: 2px solid green;
        border-radius: 2px;
    }
    .table{
        margin-bottom: 0px;
        tbody{
            tr{
                
                td{
                    font-size: 13px;
                    &:nth-child(1){
                        color: #343434;
                        font-weight: 500;
                    }
                }
            }
        }
        background-color: white;
        td{
            padding: 15px 15px;
            border: none;
        }
    }
</style>